import { get, pick, values } from 'lodash-es'

import CONSTANTS, { AVAILABILITY_STORE_TYPES } from './constants'
import GETTER_TYPES from './getter-types'

export default {
  [GETTER_TYPES.AVAILABILITY]: state => id => {
    const availabilities = values(AVAILABILITY_STORE_TYPES).reduce(
      (availabilities, storeType) => ({
        ...availabilities,
        ...get(state, [CONSTANTS.AVAILABILITY_CONSTANTS.AVAILABILITY, storeType], {}),
      }),
      {},
    )

    return Array.isArray(id) ? pick(availabilities, id) : get(availabilities, id)
  },
}
